import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { WaitlistDialog } from "../components/WaitlistDialog";
import { BookOpen, FileDown, GraduationCap, HeartHandshake } from "lucide-react";
import { Seo } from "../components/Seo";

const PLACEHOLDERS = [
  { icon: GraduationCap, title: "Life-Skills Guides", text: "Practical, easy-to-follow guides on the everyday skills school never taught." },
  { icon: FileDown, title: "Free Printables", text: "Worksheets, checklists, and planners to help you take the next step." },
  { icon: BookOpen, title: "Reading Lists", text: "Curated recommendations to support your growth journey." },
  { icon: HeartHandshake, title: "Support Directory", text: "Trusted resources for the moments you need a little extra help." },
];

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <Seo
        title="Resources — Tools for the Journey"
        description="Companion downloads, worksheets, recommended books, and practical tools to help you build a stronger, more confident life. New resources coming soon from Laura Combs Productions."
        path="/resources"
      />
      <section className="max-w-[1400px] mx-auto px-6 py-20 text-center">
        <span className="text-gold text-sm uppercase tracking-[0.3em]">Resources</span>
        <h1 className="font-serif text-5xl sm:text-6xl text-forest mt-4">Tools for the Journey</h1>
        <p className="text-charcoal/70 mt-5 leading-relaxed max-w-2xl mx-auto">
          A growing library of practical resources, guides, and tools to help you build a
          stronger, more confident life. We're adding new resources soon — check back often.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14 text-left">
          {PLACEHOLDERS.map((p) => (
            <div key={p.title} className="bg-white rounded-2xl p-8 border border-gold/25 shadow-sm" data-testid={`resource-placeholder-${p.title.toLowerCase().replace(/ /g, "-")}`}>
              <p.icon className="w-8 h-8 text-gold mb-5" strokeWidth={1.3} />
              <h3 className="font-serif text-2xl text-forest mb-2">{p.title}</h3>
              <p className="text-charcoal/60 text-sm leading-relaxed">{p.text}</p>
              <span className="inline-block mt-4 text-xs uppercase tracking-widest text-gold/70">Coming Soon</span>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 pb-20">
        <div className="bg-forest rounded-2xl p-10 sm:p-14 text-center text-ivory">
          <h2 className="font-serif text-3xl sm:text-4xl">Be the first to know</h2>
          <p className="text-ivory/80 mt-3 max-w-md mx-auto">
            Join the community and we'll let you know the moment new resources go live.
          </p>
          <div className="flex flex-wrap gap-4 justify-center mt-7">
            <WaitlistDialog source="resources">
              <Button className="rounded-full bg-gold hover:bg-gold/90 text-forest px-8 h-12 transition-colors" data-testid="resources-join-btn">
                Join the Community
              </Button>
            </WaitlistDialog>
            <Link to="/blog">
              <Button variant="outline" className="rounded-full border-ivory/40 bg-transparent text-ivory hover:bg-ivory/10 px-8 h-12" data-testid="resources-blog-btn">
                Read the Blog
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
